import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import Api from '../../../services/api';
import { toast } from "react-toastify";
import withRouter from "../../../services/withRouter";



class LegalRegistrations extends React.Component {
    
  
    componentDidMount = async () => {
        window.scrollTo(0, 0);
        this.getLegalRegistrations();
    };



    getLegalRegistrations = async()=>{
        var response = await Api.GetRequest({}, 'entrepreneurship-developement/legal-registrations');
        if(response.status == 200){
            this.setState({'legal_registrations' : response.legal_registrations});
        }
        else{
            toast.error("Something went wrong. Please try again later.");
        }
    }
  

    constructor(props) {
        super(props);
        this.state = {
            'legal_registrations' : []
        };
    }


    showPortal = async(id)=>{
        this.props.navigate("/entrepreneurship-developement/legal-registration/"+id)
    }
    
    

    render(){

        return(
            <>
                <div class="m-0 shadow"  style={{'width' : '100vw!important', 'maxWidth' : '100vw!important'}}>
                    <div class="row mx-0">
                        <div class="col-lg-12">
                            <div class="commn_banner_page" style={{'position' : 'relative'}}>
                                <img src="/assets/img/header_banner.png"/>
                                <h2 className="text-center mb-0" style={{'position' : 'absolute', 'top' : '40%', 'left' : '10%', 'color' : '#000000', "textTransform" : "uppercase"}}>Legal Compliances</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <section id="trending_causes_main" class="section_padding">
                    <div class="container">
                        <div class="row" id="counter">
                            {this.state.legal_registrations.map((registration)=>{
                                return(
                                    <div class="col-lg-3 col-md-4 col-sm-12 col-12">
                                        <div class="case_boxed_wrapper bordered" style={{'border' : '1px solid #000000'}}>
                                            <div class="case_boxed_img">
                                                <a href="javascript:;" onClick={()=>{this.showPortal(registration.id)}}>
                                                    <img src={process.env.REACT_APP_SERVER + registration.image} alt="img"/>
                                                </a>
                                            </div>
                                            <div class="causes_boxed_text">
                                                <h5 style={{'height' : '43px'}}>
                                                    <a style={{'color' : '#000000'}} href="javascript:;" onClick={()=>{this.showPortal(registration.id)}}>{registration.title}</a>
                                                </h5>
                                                <a href="javascript:;" onClick={()=>{this.showPortal(registration.id)}}><button className="btn btn_theme btn_md mt-3 py-1">Click Here</button></a>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </section>
            </>
        )
    }
}


export default withRouter(LegalRegistrations)